"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ResultsPerPage = void 0;
const react_1 = __importDefault(require("react"));
const Button_1 = require("../Buttons/Button");
require("./index.scss");
const mobx_react_1 = require("mobx-react");
const mobx_1 = require("mobx");
exports.ResultsPerPage = (0, mobx_react_1.observer)((props) => {
    const onClick = (0, mobx_1.action)((value) => {
        if (value !== props.limit) {
            props.onChange(value);
        }
    });
    const determineButtonType = (buttonValue) => buttonValue === props.limit ? 'primary-small' : 'secondary-small';
    return (react_1.default.createElement("section", { className: 'results-per-page' },
        react_1.default.createElement("p", { className: 'small bold' }, "Results Per Page:"),
        props.buttonValues.map((buttonValue, index) => (react_1.default.createElement(Button_1.Button, { key: index, mainColor: true, type: determineButtonType(buttonValue), className: "rpp-button", onClick: () => onClick(buttonValue) }, buttonValue)))));
});
